<template>
  <div class="mt-5 center">
    <!--begin::Dashboard-->
    <v-row>
      <v-col :md="(hasAvailabileTime || availabileTrialTime)?'8':'12'" cols="12">
        <div
        class="dashboard-user d-flex justify-content-center align-items-center"
      >
        <img
          :src="$store.getters.dashboardLogo"
          alt="logo"
          class="center img-fluid"
        />
      </div>
      </v-col>
      <v-col v-if="hasAvailabileTime" :md="hasAvailabileTime?'4':'12'" cols="12">
    <count-down  :membershipPlan="membershipPlan" :count="availabileTime"><ShowDetailActiveSubscription  :MerchantId="$store.getters.currentMerchant"></ShowDetailActiveSubscription></count-down>
      
      </v-col>
      <v-col v-if="availabileTrialTime && !hasAvailabileTime" :md="availabileTrialTime?'4':'12'" cols="12">
    <count-down  :membershipPlan="{title:'دوره آزمایشی'}" :count="availabileTrialTime"></count-down>
      
      </v-col>
    </v-row>
    <div style="text-align: center">
      <!-- <h1 class="my-8 blue--text">
        {{ welcomingMessage }}
      </h1> -->
         <v-alert
      shaped
      outlined
      
       type="success"
    >
    <h3 style="color: darkblue;">
        {{ welcomingMessage }}
      </h3>
    </v-alert>
    </div>
    <div   class="d-flex flex-row justify-content-center mb-5">
      <h2 >راهنمای قابلیتهای پنل کسب و کار </h2>
      
      <HelperComponent helperId="supplier-pqnel-feature" />
    </div>
    <div
      class="d-flex flex-column justify-content-center align-items-center mb-5"
    >
    
      <div v-if="!hasAvailabileTime && !availabileTrialTime">
        <v-alert
          type="warning"
          v-model="alert"
          close-label="Close Alert"
          dismissible
          shaped
        >
       <strong>
          <h4>     صنعتگر محترم،     </h4>  
          <h3 v-if=" availabileTime>0 ">
          <strong>تعداد روز باقی‌مانده از دوره آزمایشی : {{availabileTime }}</strong>
          </h3>
               دسترسی و بهره‌مندی از این بخش نیازمند فعال سازی 
          <strong>؛خدمات پایه؛</strong> 
          است. لطفاً نسبت به خرید حداقل حق اشتراک پایه    .یا 
          <a href="/financial-management/subscription">هر اشتراک مورد نیاز</a> دیگری اقدام فرمایید.  <a href="/financial-management/subscription">لینک خرید اشتراک- منوی مدیریت مالی</a>
</strong>
         
        <!-- <span class="text-dark">
          صنعتگر محترم، دسترسی و بهره‌مندی از این بخش نیازمند فعال سازی ؛خدمات
          پایه؛ است. لطفاً نسبت به خرید حداقل حق اشتراک پایه یا هر اشتراک مورد
          نیاز دیگری اقدام فرمایید.
        </span> -->

        </v-alert>
      </div>
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module';
import MixedWidget1 from '@/view/content/widgets/mixed/Widget1.vue';
import config from '../../../public/config.json';
import ShowDetailActiveSubscription from '../../modules/FinancialManagement/subscription/components/ShowDetailActiveSubscription.vue';
import CountDown from '@/components/core/CountDown.vue'
export default {
  name: 'DashboardPage',
  components: {
    MixedWidget1,
    ShowDetailActiveSubscription,
    CountDown
},
  data() {
    return {
      userBusinessInformation: [],
      welcomingMessage: '',
      alert: true,
    };
  },
  computed: {
    availabileTime() {
      return this.$store.getters.availabileTime;
    },
    availabileTrialTime() {
      return this.$store.getters.availabileTrialTime;
    },
    hasAvailabileTime() {
      
      return this.availabileTime  ? true : false;
    },
    membershipPlan() {
      return this.$store.getters.membershipPlan;
    },
    supplierTrialDays(){
      return this.$store.getters.SupplierPanelTrailDays
    }
  },
  watch: {
    '$store.getters.membershipPlan': function (after, before) {
      if (after) {
        this.computeAvailabileTime();
      }
    },
    '$store.getters.merchantInformation': function (after, before) {
      if (after) {
        this.computeAvailabileTime();
      }
    },
    '$store.getters.currentMerchantObject': function (aft, bef) {
      if (aft) {
        if (!this.$store.getters.userDetails.roles.includes('supplier')) {
          this.getSupplierInformation();
        } else {
          if (this.$store.getters.currentMerchant) {
            this.$store.dispatch('getMerchantInformation').then((data) => {
              this.userBusinessInformation = data;

              let userRole = null;
              if (!this.$store.getters.DeleteUserRoleFromDashboardMessage) {
                userRole =
                  this.userBusinessInformation.merchantCategories &&
                  this.userBusinessInformation.merchantCategories.length == 0
                    ? 'خریدار'
                    : this.$store.getters.currentMerchantObject.isManufacturer
                    ? 'صنعتگر'
                    : 'فروشنده';
              }
              let merchantName = this.$store.getters.currentMerchantObject.name;
              this.welcomingMessage = config.welcoming_message
                .replace('{user_role}', userRole ? userRole : '')
                .replace('{merchant_name}', merchantName);
            });
          }
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'داشبورد' }]);

    if (
      this.$store &&
      this.$store.getters &&
      this.$store.getters.currentMerchantObject
    ) {
      if (!this.$store.getters.userDetails.roles.includes('supplier')) {
        this.getSupplierInformation();
      } else {
        if (this.$store.getters.currentMerchant) {
          this.$store.dispatch('getMerchantInformation').then((data) => {
            this.userBusinessInformation = data;

            let userRole =
              this.userBusinessInformation.merchantCategories &&
              this.userBusinessInformation.merchantCategories.length == 0
                ? 'خریدار'
                : this.$store.getters.currentMerchantObject.isManufacturer
                ? 'صنعتگر'
                : 'فروشنده';
            let merchantName = this.$store.getters.currentMerchantObject.name;
            this.welcomingMessage = config.welcoming_message
              .replace('{user_role}', userRole)
              .replace('{merchant_name}', merchantName);
          });
        }
      }
    }
  },
  created() {
    this.computeAvailabileTime();
  },
  methods: {
    computeAvailabileTime() {
      
      if (this.$store.getters.membershipPlan) {
        var now = new Date();
        var endDateUtc = new Date(
          this.$store.getters.membershipPlan.endDateUtc
        );
        let minimize =endDateUtc.getTime() - now.getTime() ;
        var Difference_In_Days = Math.ceil(minimize / (1000 * 3600 * 24));
        this.$store.commit(
          'setAvailabileTime',
            Difference_In_Days 
        );
      } else if (this.$store.getters.merchantInformation) {
        var now = new Date();
        var approvedTimeUtc = new Date(
          this.$store.getters.merchantInformation.approvedTimeUtc
        );
        const nowTime = now.getTime()
        const approvedTimeUtcTime= approvedTimeUtc.getTime()
        let minimize = nowTime - approvedTimeUtcTime;
        var DaysPassFromApprove = Math.ceil(minimize / (1000 * 3600 * 24));
        if (DaysPassFromApprove<this.supplierTrialDays) {
          this.$store.commit(
          'setAvailabileTrialTime',
          this.supplierTrialDays- DaysPassFromApprove
        );
        }
 
      }
    },
    getSupplierInformation() {
      this.$store.dispatch('getSupplierInformation').then((data) => {
        this.userBusinessInformation = data;

        if (
          this.$store &&
          this.$store.getters &&
          this.$store.getters.currentMerchantObject
        ) {
          let userRole =
            this.userBusinessInformation.merchantCategories &&
            this.userBusinessInformation.merchantCategories.length == 0
              ? 'خریدار'
              : this.$store.getters.currentMerchantObject.isManufacturer
              ? 'صنعتگر'
              : 'فروشنده';
          let merchantName = this.$store.getters.currentMerchantObject.name;
          this.welcomingMessage = config.welcoming_message
            .replace('{user_role}', userRole)
            .replace('{merchant_name}', merchantName);
        }
      });
    },
    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll('.nav-link');
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove('active');
      }

      // set current active tab
      event.target.classList.add('active');

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute('data-tab'));
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-user {
  width: 100%;
  height: 100%;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
